const DEFAULT_AUTH_REDUX_STATE = {
  initialized: false,
  tenant: null,
  token: null,
  user: null,
};

export default DEFAULT_AUTH_REDUX_STATE;
